import { TabsDatepicker } from './TabsDatepicker';
import $ from 'jquery';
import { Preloader } from './Preloader';

export class AppointmentTabsDatepicker extends TabsDatepicker {
    constructor(...args) {
        super(...args);
        this.preloader = new Preloader($(this.element).closest('.js-form'));
    }

    fetchTime(date) {
        this.preloader.showPreloader();
        return $.ajax({
            type: 'GET',
            data: { date: date, specialist: this.employeeId },
            dataType: 'json',
            url: '/zapisatsya_na_priem/apply_date/'
        });
    }

    get employeeId() {
        return $(this.element.closest('.js-employee-appointment-form'))
            .find('input[name="employee_id"]')
            .val();
    }
}

$('.js-appointment-tabs-datepicker').each((i, element) => {
    new AppointmentTabsDatepicker(element);
});
